import PropTypes from 'prop-types';
import React from 'react';

import TeamAvatar from './TeamAvatar';
import VenueBadges from './VenueBadges';
import TeamActionsMenu from './TeamActionsMenu';
import FunctionBadges from './FunctionBadges';
import { isProtectedTeamOwner } from '../utils/teamFilterUtils';

const TeamTableRow = ({
  teamManageable,
  isSelected,
  onToggleSelect,
  onEdit,
  onDelete,
  onResetPassword,
  csrfToken,
  team,
  isLastRow
}) => {
  const handleCheckboxChange = () => {
    const uniqueId = `${teamManageable.type_for_ui}-${teamManageable.id}`;
    onToggleSelect(uniqueId);
  };

  return (
    <tr>
      <td>
        {!isProtectedTeamOwner(teamManageable, team) && (
          <input
            type="checkbox"
            className="team-checkbox"
            checked={isSelected}
            onChange={handleCheckboxChange}
            aria-label={`Select ${teamManageable.name}`}
          />
        )}
      </td>
      <td>
        <div className="team-member-info">
          <TeamAvatar
            firstName={teamManageable.first_name}
            lastName={teamManageable.last_name}
          />
          <div className="team-member-details">
            <span className="team-member-name">
              {teamManageable.first_name} {teamManageable.last_name}
              {teamManageable.owner && (
                <span className="team-owner-badge">Owner</span>
              )}
              {teamManageable.type_for_ui === 'Invitations::TeamMembership' && (
                <span className="team-invited-badge">Invited</span>
              )}
            </span>
            <span className="team-member-email">{teamManageable.email}</span>
          </div>
        </div>
      </td>
      <td data-label="Role">
        <span className="team-role-text">
          {teamManageable.role?.display_name || 'N/A'}
        </span>
      </td>
      <td data-label="Function">
        <FunctionBadges teamFunctions={teamManageable.team_functions} />
      </td>
      <td data-label="Venue Access">
        <VenueBadges
          venueOwnerships={teamManageable.venue_ownership_accesses}
          allVenueAccess={teamManageable.all_venue_access}
          maxDisplay={3}
        />
      </td>
      <td>
        <TeamActionsMenu
          teamManageable={teamManageable}
          onEdit={onEdit}
          onDelete={onDelete}
          onResetPassword={onResetPassword}
          csrfToken={csrfToken}
          team={team}
          openUpwards={isLastRow}
        />
      </td>
    </tr>
  );
};

TeamTableRow.propTypes = {
  teamManageable: PropTypes.object.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onToggleSelect: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onResetPassword: PropTypes.func.isRequired,
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  isLastRow: PropTypes.bool
};

export default TeamTableRow;
